import SFAuthService, { NO_USER } from 'app/services/sfAuth/SFAuthService'
import { backendParsers } from '../Common'
import { Case } from '../salesforce-maps/Case'
import { CommonFlowResult } from '../salesforce-maps/CommonTypes'

export const getExpressionOfInterestCasesByFlow = async (
  organizationId: string
): Promise<Case[]> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return await conn
    .requestPost<CommonFlowResult[]>('/actions/custom/flow/App_Get_EOI_Cases', {
      inputs: [
        {
          organizationId
        }
      ]
    })
    .then((response) => {
      return response[0].outputValues.cases.map((obj) => backendParsers['Case'].Salesforce.in(obj))
    })
}

export const updateCaseByFlow = async (caseRecord: Partial<Case>): Promise<CommonFlowResult[]> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return await conn.requestPost<CommonFlowResult[]>('/actions/custom/flow/App_Update_Case', {
    inputs: [
      {
        record: backendParsers['Case'].Salesforce.out(caseRecord)
      }
    ]
  })
}
